import styled from "styled-components";

const StyledHome = styled.div`
  max-width: 100%;
  padding: 3% 7%;
`;

export default StyledHome;
